import { all } from 'redux-saga/effects'

import watchGetList from './get-list'
import watchRegisterVehicle from './register-vehicle'
import watchSync from './sync'

export default function* sagas() {
  yield all([watchGetList(), watchSync(), watchRegisterVehicle()])
}
